import React, {useState, useEffect} from 'react';
import './Actus.css';

import axios from 'axios';
import { domain } from '../variables';
import PanelActu from '../components/PanelActu';

function getWindowSize() {
    const {innerWidth, innerHeight} = window;
    return {innerWidth, innerHeight};
}

function Actus() {
    const [, setWindowSize] = useState(getWindowSize()); // taille de la fenêtre
    const [actus, setActus] = useState([])

    useEffect(() => {
        getActus();
    }, []);

    useEffect(() => {

        const handleWindowResize = () => {
            setWindowSize(getWindowSize());
        }

        // à l'apparition de la page
        handleWindowResize();
    
        window.addEventListener('resize', handleWindowResize);
    
        return () => {
          window.removeEventListener('resize', handleWindowResize);
        };
      }, []);

    const getActus = async () => {
        const link = domain + '/server/getActualites.php';
        await axios.post(
            link, 
            {
                tag: 4,
                offset: 0,
                limit: 10,
            }
        ).then(res => {
            const data = res.data;
            setActus(data);
        })
    }


    return (
        <div className="actus_page">

            {/* // BANNIERE */}
            <div className={"top_banniere actus"}>
                <span className="top_banniere_title">
                    Actualités
                </span>
            </div>

            <div className="actus_container">
                {
                    actus.length > 0 &&
                    <PanelActu 
                        actualite={actus[0]} 
                        style={{width: 'auto'}}
                    />
                }
                <div className="actus_double_container">
                    {
                        actus.slice(1).map((item, index) => {
                            return (
                                <PanelActu 
                                    key={index} 
                                    actualite={item} 
                                    style={{width: getWindowSize().innerWidth > 1000 ?  "28vw" : "100vw"}}
                                />
                            )
                        })
                    }
                </div>
            </div>
            
            {/* <div className="actus_content grid">

                {
                    actus.length > 0 &&
                    <div className="item header">
                        <PanelActu 
                            actualite={actus[0]} 
                            style={{width: "50%"}}
                        />
                    </div>
                }

                {  
                    actus.slice(1).map((item, index) => {
                        return (
                            <div className='itemGrid'>
                                <PanelActu 
                                    key={index} 
                                    actualite={item} 
                                    style={{width: "50%"}}
                                />
                            </div>
                        )
                    })
                }

            </div> */}

        </div>
    );
}

export default Actus;